import React from "react"
import { PoiMediaType } from "src/models/PoiMedia"
import { SelectInput } from "react-admin"

const PoiMediaTypeInput = () => {
  return <SelectInput source="media_type" label={"Media type"} name={"media_type"} choices={Object.keys(PoiMediaType).map((key) => ({ id: PoiMediaType[key], name: key }))} />
}

export default PoiMediaTypeInput
